import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import BackButton from '../../../components/BackButton';
import HeaderTitle from '../../../components/HeaderTitle';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import { Helmet } from 'react-helmet';

function UpdateEmployee() {
    const { employeeID } = useParams();
    const form = useForm();
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth)
    const updateEmployee = (data) => {
        axios.put(`${process.env.REACT_APP_SERVICE_URL}/employees`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal('Çalışan başarıyla güncellendi', {
                    icon: 'success'
                })
                navigate(-1)
            })
            .catch((error) => {
                console.error(error)
                swal('Çalışan güncellenirken hata oluştu', {
                    icon: 'error'
                })
            })
    }

    const getEmployeeDetails = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/employees/${employeeID}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                form.setValue('firstName', response.data.firstName)
                form.setValue('lastName', response.data.lastName)
                form.setValue('phoneNumber', response.data.phoneNumber)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    useEffect(() => {
        getEmployeeDetails();
        form.setValue('id', employeeID)
    }, [])

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Çalışan Güncelle</title>
                <meta name='description' content='Çalışan bilgilerini güncelleme formu' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>
            <HeaderTitle title="Çalışan Güncelle" description="Çalışan bilgilerini güncelleme formu" />

            <div className='row'>
                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />
                            <form className='mt-3' onSubmit={form.handleSubmit(updateEmployee)}>
                                <div className='mb-3'>
                                    <label htmlFor='firstName' className='form-label'>Adı</label>
                                    <input type='text' className='form-control' id='firstName' {...form.register('firstName')} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='lastName' className='form-label'>Soyadı</label>
                                    <input type='text' className='form-control' id='lastName' {...form.register('lastName')} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='phoneNumber' className='form-label'>Telefon</label>
                                    <input type='text' className='form-control' id='phoneNumber' {...form.register('phoneNumber')} />
                                </div>
                                <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateEmployee